"use strict";

var _classCallCheck = require("C:\\Users\\germa\\Desktop\\my-portfolio\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\germa\\Desktop\\my-portfolio\\node_modules\\@babel\\runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfectionStage = void 0;

var OptionsColor_1 = require("../OptionsColor");

var InfectionStage = /*#__PURE__*/function () {
  function InfectionStage() {
    _classCallCheck(this, InfectionStage);

    this.color = new OptionsColor_1.OptionsColor();
    this.color.value = "#ff0000";
    this.radius = 0;
    this.rate = 1;
  }

  _createClass(InfectionStage, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }

      if (data.color !== undefined) {
        this.color = OptionsColor_1.OptionsColor.create(this.color, data.color);
      }

      this.duration = data.duration;
      this.infectedStage = data.infectedStage;

      if (data.radius !== undefined) {
        this.radius = data.radius;
      }

      if (data.rate !== undefined) {
        this.rate = data.rate;
      }
    }
  }]);

  return InfectionStage;
}();

exports.InfectionStage = InfectionStage;